import React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import Tooltip from "@mui/material/Tooltip";
import {formatChangePct} from "js/dashboards/components/comparison-utils";

const PILL_VARIANTS = {
  positive: {bg: "#E9F5E1", iconColor: "#107C10", textColor: "#39531E", iconClass: "bhi-trending-up"},
  negative: {bg: "#F7D9DC", iconColor: "#DA4453", textColor: "#5E131A", iconClass: "bhi-trending-down"},
  neutral:  {bg: "#F2F2F2", iconColor: "#757575", textColor: "#424242", iconClass: null},
};

export const ComparisonPill = React.memo(({changePct, higherIsBetter, testId, forceShow}) => {
  if (changePct === null) return null;
  const formatted = formatChangePct(changePct);
  if (formatted === "0" && !forceShow) return null;
  const isNeutral = changePct === 0;
  const isPositive = changePct > 0;
  const isGood = !isNeutral && (isPositive === higherIsBetter);
  const variantKey = isNeutral ? "neutral" : (isGood ? "positive" : "negative");
  const {bg, iconColor, textColor, iconClass} = PILL_VARIANTS[variantKey];
  const isCapped = formatted === ">9,999";
  const isSubPercent = formatted === "0" && forceShow;
  const sign = isCapped ? "" : (isPositive ? "+" : (changePct < 0 ? "-" : ""));
  const displayFormatted = isSubPercent ? "<1" : formatted;
  return (
    <span
      data-test-id={testId}
      style={{
        display: "inline-flex", alignItems: "center", gap: 4,
        fontSize: 11, fontWeight: 500, padding: "2px 8px", borderRadius: 5,
        background: bg, color: textColor
      }}>
      {iconClass
        ? <i className={iconClass} style={{fontSize: 11, color: iconColor}} />
        : <span style={{fontSize: 11, color: iconColor, lineHeight: 1}}>—</span>
      }
      {sign}{displayFormatted}%
    </span>
  );
});

export const HigherIsBetterToggle = React.memo(({value, onChange, testId}) => (
  <ToggleButtonGroup
    size="small"
    exclusive
    value={value}
    data-test-id={testId}
    onChange={(e, val) => { if (val !== null) onChange(val); }}>
    <ToggleButton value={true}>Good</ToggleButton>
    <ToggleButton value={false}>Bad</ToggleButton>
  </ToggleButtonGroup>
));

export const PriorPeriodComparisonControl = React.memo(({control, priorComputable, testId, ...props}) => (
  <Tooltip
    title={!priorComputable ? "Prior period can't be calculated for this timeframe (e.g. All Time)." : ""}
    placement="right">
    <span>
      <FormControlLabel
        control={control}
        label="Compare against previous period"
        disabled={!priorComputable}
        data-test-id={testId}
        {...props}
      />
    </span>
  </Tooltip>
));
